// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 954) return "js/954.js";
	if (chunkId === 953) return "js/953.js";
	if (chunkId === 966) return "js/966.js";
	if (chunkId === 40) return "js/40.js";
	// return url for filenames based on template
	return undefined;
};